<template>
    <div :style="{
        fontSize: `${fontSize}px`,
        textAlign,
        color,
        fontWeight
    }">{{ showVal }}</div>
</template>

<script>
export default {
    name: 'l-title',
    props: {
        title: {
            type: String,
            default: '标题'
        },
        fontSize: {
            type: Number,
            default: 30
        },
        textAlign: {
            type: String,
            default: 'center'
        },
        color: {
            type: String,
            default: '#000000'
        },
        fontWeight: {
            type: String,
            default: 'bold'
        },
        userId: {
            type: String,
            default: ''
        }
    },
    computed: {
        userInfo() {
            return this.lr_users[this.userId] || {}
        },
        showVal() {
            return (this.title || '').replace('{userName}', this.userInfo.f_RealName || '').replace('{workerNumber}', this.userInfo.f_Account || '').replace('{departmentName}', this.userInfo.departmentName || '')
        }
    },
    watch: {
        userId: {
            handler(newVal) {
                if (!this.$validatenull(newVal)) {
                    this.lr_loadUsers && this.lr_loadUsers(newVal);
                }
                if (this.$validatenull(newVal) && this.loginInfo) {
                    this.lr_loadUsers && this.lr_loadUsers(this.loginInfo.f_UserId);
                }
            },
            immediate: true,
        },
    }
}
</script>
<style lang="less"></style>